export default __webpack_public_path__ + "4be790cba922a82d772e760c97d10c64.png";